import React, { useState, useRef, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { CSVLink } from 'react-csv';
import { ExportButton } from './ExportBtn.styled';
import { toast } from '../../../../../redux/actions/UI';
import moment from 'moment/moment';

const ExportBtn = ({ tableRowData, message }) => {
  const dispatch = useDispatch();
  const [csvData, setCsvData] = useState('');
  const csvInstance = useRef(null);

  useEffect(() => {
    if (
      csvData &&
      csvInstance &&
      csvInstance.current &&
      csvInstance.current.link
    ) {
      setTimeout(() => {
        csvInstance.current.link.click();
        setCsvData('');
      });
    }
  }, [csvData]);

  const formatCSVExport = openTableData => {
    const exportData = [];

    for (const contactOpenData of openTableData) {
      const newCSVRows = contactOpenData.openEvents.map(event => {
        return {
          'Full Name': contactOpenData.fullName,
          'M1 ID': contactOpenData.m1_id,
          'Member ID': contactOpenData.memberId,
          Email: contactOpenData.email,
          Phone: contactOpenData.phone,
          'Open Date/Time': moment
            .unix(event.time)
            .format('MM-DD-YYYY hh:mm A'),
          'Message Subject': message.messageSubject,
        };
      });
      exportData.push(...newCSVRows);
    }
    return exportData.sort(
      (a, b) => new Date(b['Open Date/Time']) - new Date(a['Open Date/Time'])
    );
  };

  const handleExport = async () => {
    try {
      const exportData = formatCSVExport(tableRowData);
      setCsvData(exportData);
    } catch (e) {
      console.error(e);
      dispatch(toast('error', 'Failed to export open events data'));
    }
  };

  return (
    <>
      <ExportButton onClick={handleExport} disabled={!tableRowData.length}>
        Export
      </ExportButton>
      {csvData.length ? (
        <CSVLink
          data={csvData}
          filename={`Open Activity Report for ${message.messageSubject}.csv`.replaceAll(
            '/',
            '.'
          )}
          ref={csvInstance}
        />
      ) : undefined}
    </>
  );
};

export default ExportBtn;
